// extracted by mini-css-extract-plugin
export default {"houseSize":"50","menuScreenContainer":"menu_menuScreenContainer__sav1W","optionsContainer":"menu_optionsContainer__feV0T","optionLink":"menu_optionLink__IU8ik"};